// import { useState, memo, useEffect } from "react";
// import { toast } from "react-toastify";
// import PropTypes from "prop-types";
// import { useTranslation } from "next-i18next";
// import { useRouter } from "next/router";
// import PhoneInput from "react-phone-number-input";
// import en from "react-phone-number-input/locale/en";
// import "react-phone-number-input/style.css";
// import {
//   isValidPhoneNumber as isValidPhoneNumberStrict,
//   parsePhoneNumberFromString,
// } from "libphonenumber-js/max";
// // api
// import ServicesDropdown from "./services-dropdown";
// import { getCapiMeta } from "../utils/metaCookies";
// import axiosInstance from "../utils/axiosInstance";
// import { getRecaptchaToken } from "../utils/getcapthcatoken";

// const initialObject = {
//   name: "",
//   phone: "",
//   companyName: "",
//   companyEmail: "",
//   companyWebsite: "",
//   subject: "",
//   services: [],
//   message: "",
//   source: "website",
//   utm_id: "",
//   utm_source: "",
//   utm_medium: "",
//   utm_campaign: "",
//   utm_term: "",
//   utm_content: "",
// };

// const servicesList = [
//   { id: 1, name_en: "Advertising", name_ar: "الإعلان" },
//   { id: 2, name_en: "Branding", name_ar: "العلامة التجارية" },
//   { id: 3, name_en: "Content Marketing", name_ar: "تسويق المحتوى" },
//   { id: 4, name_en: "Designing", name_ar: "التصميم" },
//   { id: 5, name_en: "Digital Marketing", name_ar: "التسويق الرقمي" },
//   {
//     id: 6,
//     name_en: "E-Commerce Management",
//     name_ar: "إدارة المتاجر الالكترونية",
//   },
//   {
//     id: 7,
//     name_en: "Email Marketing",
//     name_ar: "التسويق عبر البريد الالكتروني",
//   },
//   { id: 8, name_en: "Event Management", name_ar: "إدارة المناسبات" },
//   { id: 9, name_en: "Events/Exhibitions", name_ar: "المناسبات والفعاليات" },
//   { id: 10, name_en: "Exhibition Services", name_ar: "خدمات الفعاليات" },
//   { id: 11, name_en: "EZ Digital", name_ar: "أي زد ديجيتال" },
//   { id: 12, name_en: "Lead Generation", name_ar: "توليد العملاء" },
//   { id: 13, name_en: "Mobile Applications", name_ar: "تطبيقات الموبايل" },
//   { id: 14, name_en: "Photography", name_ar: "التصوير الفوتوغرافي" },
//   { id: 15, name_en: "Public Relations", name_ar: "العلاقات العامة" },
//   { id: 16, name_en: "Retail Marketing", name_ar: "تسويق البيع بالتجزئة" },
//   { id: 17, name_en: "SEM", name_ar: "تسويق محركات البحث" },
//   { id: 18, name_en: "SEO", name_ar: "تحسين محركات البحث" },
//   {
//     id: 19,
//     name_en: "Social Media Marketing",
//     name_ar: "تسويق عبر مواقع التواصل الاجتماعي",
//   },
//   { id: 20, name_en: "Video Production", name_ar: "إنتاج الفيديو" },
//   {
//     id: 21,
//     name_en: "Web Development Services",
//     name_ar: "خدمات تطوير مواقع الويب",
//   },
//   { id: 22, name_en: "Web Services", name_ar: "خدمات الويب" },
//   {
//     id: 23,
//     name_en: "WhatsApp and SMS Marketing",
//     name_ar: "تسويق الواتساب والرسائل النصة",
//   },
//   {
//     id: 24,
//     name_en: "WhatsApp for Business API",
//     name_ar: "تطبيقات واجهة واتساب الاعمال",
//   },
//   { id: 25, name_en: "ZOHO Solutions", name_ar: "حلول زوهو" },
// ];

// const phoneLabels = {
//   ...en,
//   country: "Country",
//   phone: "Phone number",
// };

// const ContactForm = memo(({ className = "" }) => {
//   const { t } = useTranslation("common");
//   const router = useRouter();
//   const lang = router.locale || "en";

//   const [formValues, setFormValues] = useState(initialObject);
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [formToken, setFormToken] = useState("");
//   const [startedAt] = useState(() => Date.now());
//   const [websiteTrap, setWebsiteTrap] = useState("");

//   useEffect(() => {
//     const loadToken = async () => {
//       try {
//         const r = await axiosInstance.get(`/form-token?lang=${lang}`);
//         setFormToken(r?.data?.formToken || "");
//       } catch (e) {
//         console.error("Failed to load form token", e);
//         setFormToken("");
//       }
//     };

//     loadToken();
//   }, [lang]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     let nextValue = value;

//     if (name === "name") {
//       nextValue = value.replace(/[^a-zA-Z\s]/g, "");
//     }

//     setFormValues((prev) => ({ ...prev, [name]: nextValue }));
//     setErrors((prev) => ({ ...prev, [name]: "" }));
//   };

//   const handlePhoneChange = (value) => {
//     setFormValues((prev) => ({ ...prev, phone: value || "" }));
//     setErrors((prev) => ({ ...prev, phone: "" }));
//   };

//   const getValidatedMobilePhone = (phone) => {
//     if (!phone) return { ok: false, reason: "empty", normalized: "" };

//     try {
//       const parsed = parsePhoneNumberFromString(phone);

//       if (!parsed || !parsed.isValid()) {
//         return { ok: false, reason: "invalid", normalized: "" };
//       }

//       const type = parsed.getType();

//       // Allow only mobile-capable numbers
//       if (type !== "MOBILE" && type !== "FIXED_LINE_OR_MOBILE") {
//         return {
//           ok: false,
//           reason: "non_mobile",
//           normalized: parsed.number || "",
//           type,
//         };
//       }

//       return {
//         ok: true,
//         reason: "",
//         normalized: parsed.number,
//         type,
//       };
//     } catch {
//       return { ok: false, reason: "invalid", normalized: "" };
//     }
//   };

//   const getNormalizedPhone = () => {
//     const result = getValidatedMobilePhone(formValues.phone);
//     return result.ok ? result.normalized : "";
//   };

//   const PostContactFormData = async (updatedData) => {
//     const { _fbp, _fbc, eventSourceUrl } = getCapiMeta();
//     const timeOnPageMs = Date.now() - startedAt;

//     try {
//       const payload_en = {
//         name: updatedData?.name,
//         companyName: updatedData?.companyName,
//         companyEmail: updatedData?.companyEmail,
//         companyWebsite: updatedData?.companyWebsite,
//         phone: updatedData?.phone,
//         subject: updatedData?.subject,
//         services: updatedData?.services,
//         message: updatedData?.message,
//         source: updatedData?.source || "website",
//         _fbp,
//         _fbc,
//         eventSourceUrl,
//         utm_source: localStorage.getItem("utm_source"),
//         utm_campaign: localStorage.getItem("utm_campaign"),
//         formToken,
//         timeOnPageMs,
//         website: websiteTrap,
//         recaptchaToken: updatedData?.recaptchaToken,
//       };

//       const payload_ar = {
//         name_ar: updatedData?.name,
//         phone: updatedData?.phone,
//         companyName: updatedData?.companyName,
//         companyEmail: updatedData?.companyEmail,
//         companyWebsite: updatedData?.companyWebsite,
//         subject_ar: updatedData?.subject,
//         services: updatedData?.services,
//         message_ar: updatedData?.message,
//         source: updatedData?.source || "website",
//         _fbp,
//         _fbc,
//         eventSourceUrl,
//         utm_source: localStorage.getItem("utm_source"),
//         utm_campaign: localStorage.getItem("utm_campaign"),
//         formToken,
//         timeOnPageMs,
//         website: websiteTrap,
//         recaptchaToken: updatedData?.recaptchaToken,
//       };

//       const payload = lang === "ar" ? payload_ar : payload_en;

//       const response = await axiosInstance.post(
//         `/contact/testing?lang=${lang}`,
//         payload,
//       );

//       if (
//         response.status === 200 ||
//         response.status === 201 ||
//         response.status === 202
//       ) {
//         setLoading(false);
//         toast.success(
//           response.data.message ||
//             "We have received your query. Our team will get in touch with you shortly.",
//         );
//         setFormValues({ ...initialObject });
//         setErrors({});
//       }
//     } catch (error) {
//       console.error("Error posting Data:", error);
//       setLoading(false);
//       toast.error(
//         error?.response?.data?.error ||
//           error?.response?.data?.errors?.[0] ||
//           error?.response?.data?.message ||
//           "Something Went wrong!",
//       );
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!formToken) {
//       toast.error("Please wait a moment and try again.");
//       return;
//     }

//     const {
//       name,
//       companyName,
//       companyEmail,
//       companyWebsite,
//       subject,
//       services,
//       message,
//       phone,
//     } = formValues;

//     const validationErrors = {};

//     const websiteRegex =
//       /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/\S*)?$/;
//     const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

//     const nameRegex = /^[A-Za-z\s]+$/;

//     if (!name.trim()) {
//       validationErrors.name = "Please Enter Full Name.";
//     } else if (!nameRegex.test(name.trim())) {
//       validationErrors.name = "Full Name must contain letters only.";
//     }
//     if (!companyName)
//       validationErrors.companyName = "Please Enter Company Name.";

//     if (!companyWebsite) {
//       validationErrors.companyWebsite = "Please Enter Company Website.";
//     } else if (!websiteRegex.test(companyWebsite)) {
//       validationErrors.companyWebsite = "Please enter a valid website URL.";
//     }

//     const phoneCheck = getValidatedMobilePhone(phone);

//     if (!phone) {
//       validationErrors.phone = "Please Enter Phone Number.";
//     } else if (!phoneCheck.ok) {
//       if (phoneCheck.reason === "invalid") {
//         validationErrors.phone = "Please enter a valid phone number.";
//       } else if (phoneCheck.reason === "non_mobile") {
//         validationErrors.phone =
//           "Only mobile numbers are allowed (no landline, toll-free, or VoIP).";
//       }
//     }

//     if (!companyEmail) {
//       validationErrors.companyEmail = "Please Enter Email.";
//     } else if (!emailRegex.test(companyEmail)) {
//       validationErrors.companyEmail = "Invalid email address.";
//     }

//     if (!subject) validationErrors.subject = "Please Enter Subject.";
//     if (!services.length) validationErrors.services = "Please select service.";
//     if (!message) validationErrors.message = "Please Enter Message.";

//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }

//     setLoading(true);

//     try {
//       const recaptchaToken = await getRecaptchaToken("contact_submit");
//       const phoneCheck = getValidatedMobilePhone(phone);

//       const updatedData = {
//         ...formValues,
//         phone: phoneCheck.normalized,
//         recaptchaToken,
//       };

//       await PostContactFormData(updatedData);
//     } catch (err) {
//       console.error(err);
//       toast.error("Verification failed. Please try again.");
//       setLoading(false);
//     }
//   };

//   const normalizedPreview = getNormalizedPhone();

//   return (
//     <section
//       id="contact-form"
//       className={`contact-form-sec w-full bg-text-primary overflow-hidden flex flex-row items-start justify-start py-[40px] lg:py-[60px] px-6 sm:px-6 lg:px-20 box-border max-w-full text-45xl text-background-color-primary ${className}`}
//     >
//       <style jsx global>{`
//         .custom-phone-input {
//           --PhoneInputCountryFlag-height: 18px;
//           --PhoneInput-color--focus: transparent;
//         }

//         .custom-phone-input .PhoneInput {
//           display: flex;
//           align-items: center;
//           width: 100%;
//           gap: 12px;
//           border-bottom: 1px solid rgba(255, 255, 255, 0.24);
//           padding-bottom: 8px;
//         }

//         .custom-phone-input .PhoneInputCountry {
//           margin-right: 0;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .custom-phone-input .PhoneInputCountrySelect {
//           background: transparent;
//           color: inherit;
//           border: 0;
//           outline: none;
//           font-size: 16px;
//           cursor: pointer;
//           width: 100%;
//         }

//         .custom-phone-input .PhoneInputCountrySelect option {
//           color: #111827;
//         }

//         .custom-phone-input .PhoneInputCountryIcon {
//           box-shadow: none;
//           background: transparent;
//         }

//         .custom-phone-input .PhoneInputCountryIconImg {
//           display: block;
//         }

//         .custom-phone-input .PhoneInputInput {
//           flex: 1;
//           width: 100%;
//           min-width: 0;
//           background: transparent;
//           color: inherit;
//           border: 0;
//           outline: none;
//           font-size: 16px;
//           padding: 0;
//         }

//         .custom-phone-input .PhoneInputInput::placeholder {
//           color: white;
//           opacity: 1;
//         }

//         .custom-phone-input .PhoneInputCountrySelectArrow {
//           opacity: 0.8;
//         }
//       `}</style>

//       <div className="w-full box-border flex-1 flex flex-col lg:flex-row items-start justify-start gap-[60px] max-w-[1600px] mx-auto">
//         <h2 className="m-0 w-full lg:w-1/3 relative text-[28px] sm:text-[32px] lg:text-[50px] leading-[120%] font-medium font-[inherit] inline-block shrink-0 max-w-full">
//           {t("getInTouch.title")}
//         </h2>

//         <form
//           className="flex-1 flex flex-col items-start justify-start gap-6 w-full box-border text-base"
//           onSubmit={handleSubmit}
//         >
//           <div className="self-stretch flex flex-col items-start justify-start gap-8 max-w-full w-full">
//             <div className="self-stretch flex flex-col lg:flex-row items-start justify-start gap-4 max-w-full">
//               <div className="w-full flex-1 flex flex-col gap-2">
//                 <input
//                   type="text"
//                   id="name"
//                   name="name"
//                   value={formValues.name}
//                   onChange={handleInputChange}
//                   className="text-[16px] border-b border-gray-300 bg-transparent text-background-color-primary outline-none pb-2 placeholder:text-white"
//                   placeholder={t("getInTouch.form.name")}
//                   inputMode="text"
//                   autoComplete="name"
//                 />
//                 {errors?.name && (
//                   <p className="m-0 text-[14px]" style={{ color: "red" }}>
//                     {errors.name}
//                   </p>
//                 )}
//               </div>

//               <div className="w-full flex-1 flex flex-col gap-2">
//                 <input
//                   type="text"
//                   id="companyName"
//                   name="companyName"
//                   value={formValues.companyName}
//                   onChange={handleInputChange}
//                   className="text-[16px] border-b border-gray-300 bg-transparent text-background-color-primary outline-none pb-2 placeholder:text-white"
//                   placeholder={t("getInTouch.form.company")}
//                 />
//                 {errors?.companyName && (
//                   <p className="m-0 text-[14px]" style={{ color: "red" }}>
//                     {errors.companyName}
//                   </p>
//                 )}
//               </div>
//             </div>

//             <div className="self-stretch flex flex-col lg:flex-row items-start justify-start gap-4 max-w-full">
//               <div className="w-full flex-1 flex flex-col gap-2">
//                 <input
//                   type="email"
//                   id="companyEmail"
//                   name="companyEmail"
//                   value={formValues.companyEmail}
//                   onChange={handleInputChange}
//                   className="text-[16px] border-b border-gray-300 bg-transparent text-background-color-primary outline-none pb-2 placeholder:text-white"
//                   placeholder={t("getInTouch.form.cemail")}
//                 />
//                 {errors?.companyEmail && (
//                   <p className="m-0 text-[14px]" style={{ color: "red" }}>
//                     {errors.companyEmail}
//                   </p>
//                 )}
//               </div>

//               <div className="w-full flex-1 flex flex-col gap-2">
//                 <input
//                   type="text"
//                   id="companyWebsite"
//                   name="companyWebsite"
//                   value={formValues.companyWebsite}
//                   onChange={handleInputChange}
//                   className="text-[16px] border-b border-gray-300 bg-transparent text-background-color-primary outline-none pb-2 placeholder:text-white"
//                   placeholder={t("getInTouch.form.website")}
//                 />
//                 {errors?.companyWebsite && (
//                   <p className="m-0 text-[14px]" style={{ color: "red" }}>
//                     {errors.companyWebsite}
//                   </p>
//                 )}
//               </div>
//             </div>

//             <div className="self-stretch flex flex-col lg:flex-row items-start justify-start gap-4 max-w-full">
//               <div className="w-full flex-1 flex flex-col gap-2" dir="ltr">
//                 <div className="custom-phone-input">
//                   <PhoneInput
//                     id="phone"
//                     name="phone"
//                     defaultCountry="AE"
//                     international
//                     withCountryCallingCode
//                     labels={phoneLabels}
//                     value={formValues.phone}
//                     onChange={handlePhoneChange}
//                     className="w-full text-background-color-primary"
//                   />
//                 </div>

//                 {errors?.phone ? (
//                   <p className="m-0 text-[14px]" style={{ color: "red" }}>
//                     {errors.phone}
//                   </p>
//                 ) : (
//                   <p className="m-0 text-[14px]" style={{ color: "orange" }}>
//                     {normalizedPreview
//                       ? `Will send as: ${normalizedPreview}`
//                       : "Use international format +971xx, +91xx, etc."}
//                   </p>
//                 )}
//               </div>
//             </div>

//             <div className="w-full flex flex-col gap-2">
//               <input
//                 type="text"
//                 id="subject"
//                 name="subject"
//                 value={formValues.subject}
//                 onChange={handleInputChange}
//                 className="text-[16px] border-b border-gray-300 bg-transparent text-background-color-primary outline-none pb-2 w-full placeholder:text-white"
//                 placeholder={t("getInTouch.form.subject")}
//               />
//               {errors?.subject && (
//                 <p className="m-0 text-[14px]" style={{ color: "red" }}>
//                   {errors.subject}
//                 </p>
//               )}
//             </div>

//             <ServicesDropdown
//               services={servicesList}
//               value={formValues.services}
//               onChange={(next) => {
//                 setFormValues((prev) => ({ ...prev, services: next }));
//                 setErrors((prev) => ({ ...prev, services: "" }));
//               }}
//               lang={lang}
//               t={t}
//               error={errors?.services}
//             />

//             <div className="w-full flex flex-col gap-2">
//               <textarea
//                 id="message"
//                 name="message"
//                 value={formValues.message}
//                 onChange={handleInputChange}
//                 rows={4}
//                 className="text-[16px] border-b border-gray-300 bg-transparent text-background-color-primary outline-none pb-2 w-full resize-none placeholder:text-white"
//                 placeholder={t("getInTouch.form.message")}
//               />
//               {errors?.message && (
//                 <p className="m-0 text-[14px]" style={{ color: "red" }}>
//                   {errors.message}
//                 </p>
//               )}
//             </div>
//           </div>

//           <input
//             type="text"
//             name="website"
//             value={websiteTrap}
//             onChange={(e) => setWebsiteTrap(e.target.value)}
//             autoComplete="off"
//             tabIndex={-1}
//             style={{
//               position: "absolute",
//               left: "-10000px",
//               top: "auto",
//               width: "1px",
//               height: "1px",
//               overflow: "hidden",
//             }}
//           />

//           <button
//             type="submit"
//             className="rounded-[50px] bg-crimson text-white text-[16px] font-medium py-3 px-6 cursor-pointer hover:bg-[#e72c46] transition duration-300 ease-in-out disabled:opacity-70 disabled:cursor-not-allowed"
//             disabled={loading}
//           >
//             {loading ? "Verifying..." : t("getInTouch.form.btnTxt")}
//           </button>
//         </form>
//       </div>
//     </section>
//   );
// });

// ContactForm.propTypes = {
//   className: PropTypes.string,
// };

// export default ContactForm;

import { useState, memo, useEffect, useMemo } from "react";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import PhoneInput from "react-phone-number-input";
import en from "react-phone-number-input/locale/en";
import "react-phone-number-input/style.css";
import {
  isValidPhoneNumber as isValidPhoneNumberStrict,
  parsePhoneNumberFromString,
} from "libphonenumber-js/max";
import Select from "react-select";
// api
import { getCapiMeta } from "../utils/metaCookies";
import axiosInstance from "../utils/axiosInstance";
import { getRecaptchaToken } from "../utils/getcapthcatoken";

const initialObject = {
  name: "",
  phone: "",
  companyName: "",
  companyEmail: "",
  companyWebsite: "",
  subject: "",
  services: [],
  message: "",
  source: "website",
  utm_id: "",
  utm_source: "",
  utm_medium: "",
  utm_campaign: "",
  utm_term: "",
  utm_content: "",
};

const servicesList = [
  { id: 1, name_en: "Advertising", name_ar: "الإعلان" },
  { id: 2, name_en: "Branding", name_ar: "العلامة التجارية" },
  { id: 3, name_en: "Content Marketing", name_ar: "تسويق المحتوى" },
  { id: 4, name_en: "Designing", name_ar: "التصميم" },
  { id: 5, name_en: "Digital Marketing", name_ar: "التسويق الرقمي" },
  {
    id: 6,
    name_en: "E-Commerce Management",
    name_ar: "إدارة المتاجر الالكترونية",
  },
  {
    id: 7,
    name_en: "Email Marketing",
    name_ar: "التسويق عبر البريد الالكتروني",
  },
  { id: 8, name_en: "Event Management", name_ar: "إدارة المناسبات" },
  { id: 9, name_en: "Events/Exhibitions", name_ar: "المناسبات والفعاليات" },
  { id: 10, name_en: "Exhibition Services", name_ar: "خدمات الفعاليات" },
  { id: 11, name_en: "EZ Digital", name_ar: "أي زد ديجيتال" },
  { id: 12, name_en: "Lead Generation", name_ar: "توليد العملاء" },
  { id: 13, name_en: "Mobile Applications", name_ar: "تطبيقات الموبايل" },
  { id: 14, name_en: "Photography", name_ar: "التصوير الفوتوغرافي" },
  { id: 15, name_en: "Public Relations", name_ar: "العلاقات العامة" },
  { id: 16, name_en: "Retail Marketing", name_ar: "تسويق البيع بالتجزئة" },
  { id: 17, name_en: "SEM", name_ar: "تسويق محركات البحث" },
  { id: 18, name_en: "SEO", name_ar: "تحسين محركات البحث" },
  {
    id: 19,
    name_en: "Social Media Marketing",
    name_ar: "تسويق عبر مواقع التواصل الاجتماعي",
  },
  { id: 20, name_en: "Video Production", name_ar: "إنتاج الفيديو" },
  {
    id: 21,
    name_en: "Web Development Services",
    name_ar: "خدمات تطوير مواقع الويب",
  },
  { id: 22, name_en: "Web Services", name_ar: "خدمات الويب" },
  {
    id: 23,
    name_en: "WhatsApp and SMS Marketing",
    name_ar: "تسويق الواتساب والرسائل النصة",
  },
  {
    id: 24,
    name_en: "WhatsApp for Business API",
    name_ar: "تطبيقات واجهة واتساب الاعمال",
  },
  { id: 25, name_en: "ZOHO Solutions", name_ar: "حلول زوهو" },
];

const phoneLabels = {
  ...en,
  country: "Country",
  phone: "Phone number",
};

const ContactForm = memo(({ className = "" }) => {
  const { t } = useTranslation("common");
  const router = useRouter();
  const lang = router.locale || "en";

  const [formValues, setFormValues] = useState(initialObject);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [formToken, setFormToken] = useState("");
  const [startedAt] = useState(() => Date.now());
  const [websiteTrap, setWebsiteTrap] = useState("");

  useEffect(() => {
    const loadToken = async () => {
      try {
        const r = await axiosInstance.get(`/form-token?lang=${lang}`);
        setFormToken(r?.data?.formToken || "");
      } catch (e) {
        console.error("Failed to load form token", e);
        setFormToken("");
      }
    };

    loadToken();
  }, [lang]);

  const serviceOptions = useMemo(
    () =>
      servicesList.map((s) => ({
        value: lang === "ar" ? s.name_ar : s.name_en,
        label: lang === "ar" ? s.name_ar : s.name_en,
      })),
    [lang],
  );

  const selectedServices = useMemo(
    () =>
      serviceOptions.filter((option) =>
        formValues.services.includes(option.value),
      ),
    [serviceOptions, formValues.services],
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let nextValue = value;

    if (name === "name") {
      nextValue = value.replace(/[^a-zA-Z\s]/g, "");
    }

    setFormValues((prev) => ({ ...prev, [name]: nextValue }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handlePhoneChange = (value) => {
    setFormValues((prev) => ({ ...prev, phone: value || "" }));
    setErrors((prev) => ({ ...prev, phone: "" }));
  };

  const handleServicesChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((item) => item.value)
      : [];

    setFormValues((prev) => ({ ...prev, services: values }));
    setErrors((prev) => ({ ...prev, services: "" }));
  };

  const getValidatedMobilePhone = (phone) => {
    if (!phone) return { ok: false, reason: "empty", normalized: "" };

    try {
      const parsed = parsePhoneNumberFromString(phone);

      if (!parsed || !parsed.isValid()) {
        return { ok: false, reason: "invalid", normalized: "" };
      }

      const type = parsed.getType();

      // Allow only mobile-capable numbers
      if (type !== "MOBILE" && type !== "FIXED_LINE_OR_MOBILE") {
        return {
          ok: false,
          reason: "non_mobile",
          normalized: parsed.number || "",
          type,
        };
      }

      return {
        ok: true,
        reason: "",
        normalized: parsed.number,
        type,
      };
    } catch {
      return { ok: false, reason: "invalid", normalized: "" };
    }
  };

  const getNormalizedPhone = () => {
    const result = getValidatedMobilePhone(formValues.phone);
    return result.ok ? result.normalized : "";
  };

  const PostContactFormData = async (updatedData) => {
    const { _fbp, _fbc, eventSourceUrl } = getCapiMeta();
    const timeOnPageMs = Date.now() - startedAt;

    try {
      const payload_en = {
        name: updatedData?.name,
        companyName: updatedData?.companyName,
        companyEmail: updatedData?.companyEmail,
        companyWebsite: updatedData?.companyWebsite,
        phone: updatedData?.phone,
        subject: updatedData?.subject,
        services: updatedData?.services,
        message: updatedData?.message,
        source: updatedData?.source || "website",
        _fbp,
        _fbc,
        eventSourceUrl,
        utm_source: localStorage.getItem("utm_source"),
        utm_campaign: localStorage.getItem("utm_campaign"),
        formToken,
        timeOnPageMs,
        website: websiteTrap,
        recaptchaToken: updatedData?.recaptchaToken,
      };

      const payload_ar = {
        name_ar: updatedData?.name,
        phone: updatedData?.phone,
        companyName: updatedData?.companyName,
        companyEmail: updatedData?.companyEmail,
        companyWebsite: updatedData?.companyWebsite,
        subject_ar: updatedData?.subject,
        services: updatedData?.services,
        message_ar: updatedData?.message,
        source: updatedData?.source || "website",
        _fbp,
        _fbc,
        eventSourceUrl,
        utm_source: localStorage.getItem("utm_source"),
        utm_campaign: localStorage.getItem("utm_campaign"),
        formToken,
        timeOnPageMs,
        website: websiteTrap,
        recaptchaToken: updatedData?.recaptchaToken,
      };

      const payload = lang === "ar" ? payload_ar : payload_en;

      const response = await axiosInstance.post(
        `/contact/testing?lang=${lang}`,
        payload,
      );

      if (
        response.status === 200 ||
        response.status === 201 ||
        response.status === 202
      ) {
        setLoading(false);
        toast.success(
          response.data.message ||
            "We have received your query. Our team will get in touch with you shortly.",
        );
        setFormValues({ ...initialObject });
        setErrors({});
      }
    } catch (error) {
      console.error("Error posting Data:", error);
      setLoading(false);
      toast.error(
        error?.response?.data?.error ||
          error?.response?.data?.errors?.[0] ||
          error?.response?.data?.message ||
          "Something Went wrong!",
      );
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formToken) {
      toast.error("Please wait a moment and try again.");
      return;
    }

    const {
      name,
      companyName,
      companyEmail,
      companyWebsite,
      subject,
      services,
      message,
      phone,
    } = formValues;

    const validationErrors = {};

    const websiteRegex =
      /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/\S*)?$/;
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

    const nameRegex = /^[A-Za-z\s]+$/;

    if (!name.trim()) {
      validationErrors.name = "Please Enter Full Name.";
    } else if (!nameRegex.test(name.trim())) {
      validationErrors.name = "Full Name must contain letters only.";
    }
    if (!companyName)
      validationErrors.companyName = "Please Enter Company Name.";

    if (!companyWebsite) {
      validationErrors.companyWebsite = "Please Enter Company Website.";
    } else if (!websiteRegex.test(companyWebsite)) {
      validationErrors.companyWebsite = "Please enter a valid website URL.";
    }

    const phoneCheck = getValidatedMobilePhone(phone);

    if (!phone) {
      validationErrors.phone = "Please Enter Phone Number.";
    } else if (!phoneCheck.ok) {
      if (phoneCheck.reason === "invalid") {
        validationErrors.phone = "Please enter a valid phone number.";
      } else if (phoneCheck.reason === "non_mobile") {
        validationErrors.phone =
          "Only mobile numbers are allowed (no landline, toll-free, or VoIP).";
      }
    }

    if (!companyEmail) {
      validationErrors.companyEmail = "Please Enter Email.";
    } else if (!emailRegex.test(companyEmail)) {
      validationErrors.companyEmail = "Invalid email address.";
    }

    if (!subject) validationErrors.subject = "Please Enter Subject.";
    if (!services.length) validationErrors.services = "Please select service.";
    if (!message) validationErrors.message = "Please Enter Message.";

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);

    try {
      const recaptchaToken = await getRecaptchaToken("contact_submit");
      const phoneCheck = getValidatedMobilePhone(phone);

      const updatedData = {
        ...formValues,
        phone: phoneCheck.normalized,
        recaptchaToken,
      };

      await PostContactFormData(updatedData);
    } catch (err) {
      console.error(err);
      toast.error("Verification failed. Please try again.");
      setLoading(false);
    }
  };

  // react-select styles tuned for ContactForm's dark theme
  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "auto",
      background: "transparent",
      border: "none",
      borderBottom: `1px solid ${
        errors?.services ? "red" : "rgba(255, 255, 255, 0.24)"
      }`,
      borderRadius: 0,
      boxShadow: "none",
      paddingBottom: "6px",
      cursor: "text",
      "&:hover": {
        borderBottom: `1px solid ${
          errors?.services ? "red" : "rgba(255, 255, 255, 0.24)"
        }`,
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: 0,
      gap: "6px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#fff",
      opacity: 1,
      fontSize: "16px",
      margin: 0,
    }),
    input: (provided) => ({
      ...provided,
      color: "#fff",
      margin: 0,
      padding: 0,
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "rgba(255,255,255,0.7)",
      padding: "4px",
      "&:hover": {
        color: "#fff",
      },
    }),
    clearIndicator: (provided) => ({
      ...provided,
      color: "rgba(255,255,255,0.7)",
      padding: "4px",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "rgba(255,255,255,0.12)",
      borderRadius: "4px",
      paddingLeft: "2px",
      paddingRight: "2px",
      margin: "2px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#fff",
      fontSize: "13px",
      fontWeight: 500,
      padding: "4px 6px",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#fff",
      borderRadius: "4px",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "rgba(255,255,255,0.24)",
        color: "#fff",
      },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 30,
      backgroundColor: "#000",
      border: "1px solid rgba(255,255,255,0.24)",
      borderRadius: "6px",
      overflow: "hidden",
      boxShadow: "0 10px 30px rgba(0,0,0,0.4)",
    }),
    menuList: (provided) => ({
      ...provided,
      paddingTop: "6px",
      paddingBottom: "6px",
      maxHeight: "220px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "rgba(255,255,255,0.16)"
        : state.isFocused
          ? "rgba(255,255,255,0.08)"
          : "transparent",
      color: "#fff",
      cursor: "pointer",
      fontSize: "14px",
      padding: "10px 14px",
    }),
    noOptionsMessage: (provided) => ({
      ...provided,
      fontSize: "14px",
      color: "rgba(255,255,255,0.7)",
    }),
  };

  const normalizedPreview = getNormalizedPhone();

  return (
    <section
      id="contact-form"
      className={`contact-form-sec w-full bg-text-primary overflow-hidden flex flex-row items-start justify-start py-[40px] lg:py-[60px] px-6 sm:px-6 lg:px-20 box-border max-w-full text-45xl text-background-color-primary ${className}`}
    >
      <style jsx global>{`
        .custom-phone-input {
          --PhoneInputCountryFlag-height: 18px;
          --PhoneInput-color--focus: transparent;
        }

        .custom-phone-input .PhoneInput {
          display: flex;
          align-items: center;
          width: 100%;
          gap: 12px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.24);
          padding-bottom: 8px;
        }

        .custom-phone-input .PhoneInputCountry {
          margin-right: 0;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .custom-phone-input .PhoneInputCountrySelect {
          background: transparent;
          color: inherit;
          border: 0;
          outline: none;
          font-size: 16px;
          cursor: pointer;
          width: 100%;
        }

        .custom-phone-input .PhoneInputCountrySelect option {
          color: #111827;
        }

        .custom-phone-input .PhoneInputCountryIcon {
          box-shadow: none;
          background: transparent;
        }

        .custom-phone-input .PhoneInputCountryIconImg {
          display: block;
        }

        .custom-phone-input .PhoneInputInput {
          flex: 1;
          width: 100%;
          min-width: 0;
          background: transparent;
          color: inherit;
          border: 0;
          outline: none;
          font-size: 16px;
          padding: 0;
        }

        .custom-phone-input .PhoneInputInput::placeholder {
          color: white;
          opacity: 1;
        }

        .custom-phone-input .PhoneInputCountrySelectArrow {
          opacity: 0.8;
        }
      `}</style>

      <div className="w-full box-border flex-1 flex flex-col lg:flex-row items-start justify-start gap-[60px] max-w-[1600px] mx-auto">
        <h2 className="m-0 w-full lg:w-1/3 relative text-[28px] sm:text-[32px] lg:text-[50px] leading-[120%] font-medium font-[inherit] inline-block shrink-0 max-w-full">
          {t("getInTouch.title")}
        </h2>

        <form
          className="flex-1 flex flex-col items-start justify-start gap-6 w-full box-border text-base"
          onSubmit={handleSubmit}
        >
          <div className="self-stretch flex flex-col items-start justify-start gap-8 max-w-full w-full">
            <div className="self-stretch flex flex-col lg:flex-row items-start justify-start gap-4 max-w-full">
              <div className="w-full flex-1 flex flex-col gap-2">
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formValues.name}
                  onChange={handleInputChange}
                  className="text-[16px] border-b border-gray-300 bg-transparent text-background-color-primary outline-none pb-2 placeholder:text-white"
                  placeholder={t("getInTouch.form.name")}
                  inputMode="text"
                  autoComplete="name"
                />
                {errors?.name && (
                  <p className="m-0 text-[14px]" style={{ color: "red" }}>
                    {errors.name}
                  </p>
                )}
              </div>

              <div className="w-full flex-1 flex flex-col gap-2">
                <input
                  type="text"
                  id="companyName"
                  name="companyName"
                  value={formValues.companyName}
                  onChange={handleInputChange}
                  className="text-[16px] border-b border-gray-300 bg-transparent text-background-color-primary outline-none pb-2 placeholder:text-white"
                  placeholder={t("getInTouch.form.company")}
                />
                {errors?.companyName && (
                  <p className="m-0 text-[14px]" style={{ color: "red" }}>
                    {errors.companyName}
                  </p>
                )}
              </div>
            </div>

            <div className="self-stretch flex flex-col lg:flex-row items-start justify-start gap-4 max-w-full">
              <div className="w-full flex-1 flex flex-col gap-2">
                <input
                  type="email"
                  id="companyEmail"
                  name="companyEmail"
                  value={formValues.companyEmail}
                  onChange={handleInputChange}
                  className="text-[16px] border-b border-gray-300 bg-transparent text-background-color-primary outline-none pb-2 placeholder:text-white"
                  placeholder={t("getInTouch.form.cemail")}
                />
                {errors?.companyEmail && (
                  <p className="m-0 text-[14px]" style={{ color: "red" }}>
                    {errors.companyEmail}
                  </p>
                )}
              </div>

              <div className="w-full flex-1 flex flex-col gap-2">
                <input
                  type="text"
                  id="companyWebsite"
                  name="companyWebsite"
                  value={formValues.companyWebsite}
                  onChange={handleInputChange}
                  className="text-[16px] border-b border-gray-300 bg-transparent text-background-color-primary outline-none pb-2 placeholder:text-white"
                  placeholder={t("getInTouch.form.website")}
                />
                {errors?.companyWebsite && (
                  <p className="m-0 text-[14px]" style={{ color: "red" }}>
                    {errors.companyWebsite}
                  </p>
                )}
              </div>
            </div>

            <div className="self-stretch flex flex-col lg:flex-row items-start justify-start gap-4 max-w-full">
              <div className="w-full flex-1 flex flex-col gap-2" dir="ltr">
                <div className="custom-phone-input">
                  <PhoneInput
                    id="phone"
                    name="phone"
                    defaultCountry="AE"
                    international
                    withCountryCallingCode
                    labels={phoneLabels}
                    value={formValues.phone}
                    onChange={handlePhoneChange}
                    className="w-full text-background-color-primary"
                  />
                </div>

                {errors?.phone ? (
                  <p className="m-0 text-[14px]" style={{ color: "red" }}>
                    {errors.phone}
                  </p>
                ) : (
                  <p className="m-0 text-[14px]" style={{ color: "orange" }}>
                    {normalizedPreview
                      ? `Will send as: ${normalizedPreview}`
                      : "Use international format +971xx, +91xx, etc."}
                  </p>
                )}
              </div>
            </div>

            <div className="w-full flex flex-col gap-2">
              <input
                type="text"
                id="subject"
                name="subject"
                value={formValues.subject}
                onChange={handleInputChange}
                className="text-[16px] border-b border-gray-300 bg-transparent text-background-color-primary outline-none pb-2 w-full placeholder:text-white"
                placeholder={t("getInTouch.form.subject")}
              />
              {errors?.subject && (
                <p className="m-0 text-[14px]" style={{ color: "red" }}>
                  {errors.subject}
                </p>
              )}
            </div>

            <div className="w-full flex flex-col gap-2">
              <Select
                isMulti
                isSearchable
                name="services"
                options={serviceOptions}
                value={selectedServices}
                onChange={handleServicesChange}
                placeholder={
                  t("getInTouch.form.services") || "Select service(s)"
                }
                styles={customSelectStyles}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                isRtl={lang === "ar"}
                noOptionsMessage={() =>
                  lang === "ar" ? "لا توجد نتائج" : "No services found"
                }
              />
              {errors?.services && (
                <p className="m-0 text-[14px]" style={{ color: "red" }}>
                  {errors.services}
                </p>
              )}
            </div>

            <div className="w-full flex flex-col gap-2">
              <textarea
                id="message"
                name="message"
                value={formValues.message}
                onChange={handleInputChange}
                rows={4}
                className="text-[16px] border-b border-gray-300 bg-transparent text-background-color-primary outline-none pb-2 w-full resize-none placeholder:text-white"
                placeholder={t("getInTouch.form.message")}
              />
              {errors?.message && (
                <p className="m-0 text-[14px]" style={{ color: "red" }}>
                  {errors.message}
                </p>
              )}
            </div>
          </div>

          <input
            type="text"
            name="website"
            value={websiteTrap}
            onChange={(e) => setWebsiteTrap(e.target.value)}
            autoComplete="off"
            tabIndex={-1}
            style={{
              position: "absolute",
              left: "-10000px",
              top: "auto",
              width: "1px",
              height: "1px",
              overflow: "hidden",
            }}
          />

          <button
            type="submit"
            className="rounded-[50px] bg-crimson text-white text-[16px] font-medium py-3 px-6 cursor-pointer hover:bg-[#e72c46] transition duration-300 ease-in-out disabled:opacity-70 disabled:cursor-not-allowed contact_form"
            disabled={loading}
          >
            {loading ? "Verifying..." : t("getInTouch.form.btnTxt")}
          </button>
        </form>
      </div>
    </section>
  );
});

ContactForm.propTypes = {
  className: PropTypes.string,
};

export default ContactForm;
